/** Page size for the notification center list. */
export const NOTIFICATION_PAGE_SIZE = 20

/** Badge stops counting here; higher unread counts render as `<max>+`. */
export const NOTIFICATION_BADGE_MAX = 99

/** List filter tabs on the notification center page. */
export const NOTIFICATION_FILTER = Object.freeze({
  ALL: 'all',
  UNREAD: 'unread',
})

/** Server notification `type` values — keep in sync with the API model. */
export const NOTIFICATION_TYPE = Object.freeze({
  TICKET_ASSIGNED: 'ticket_assigned',
  TICKET_UNASSIGNED: 'ticket_unassigned',
  TICKET_CREATED: 'ticket_created',
  TASK_ASSIGNED: 'task_assigned',
  TASK_UNASSIGNED: 'task_unassigned',
  TASK_CREATED: 'task_created',
})
